import React from 'react';
import { Button } from '@fiverr-private/button';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography, Heading, Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { TERMS_AND_CONDITIONS_LINKS } from '../../../constants';
import InviteIcon from '../../assets/invite.svg';
import DiscountIcon from '../../assets/discount.svg';
import CreditIcon from '../../assets/credit.svg';
import { useUser } from '../../hooks/useUser';

const STEPS = [
  {
    id: 'invite',
    icon: InviteIcon,
    title: 'referral_program_perseus.steps_to_reward.invite_title',
    text: 'referral_program_perseus.steps_to_reward.invite_text',
  },
  {
    id: 'discount',
    icon: DiscountIcon,
    title: 'referral_program_perseus.steps_to_reward.discount_title',
    text: 'referral_program_perseus.steps_to_reward.discount_text',
  },
  {
    id: 'credit',
    icon: CreditIcon,
    title: 'referral_program_perseus.steps_to_reward.credit_title',
    text: 'referral_program_perseus.steps_to_reward.credit_text',
  },
];

export const StepsToReward = () => {
  const user = useUser();
  const isGuest = !user;

  const termsAndConditionsLink = isGuest
    ? TERMS_AND_CONDITIONS_LINKS.GUEST_STEPS
    : TERMS_AND_CONDITIONS_LINKS.USER_STEPS;

  const onTermsClick = () => {
    mixpanelTrack('Referral Page Inviter - Terms and Conditions - Click', { Place: 'Steps to Reward' });
  };

  return (
    <Container as="section" data-testid="steps" display="flex" justifyContent="center" alignItems="center">
      <Container
        width="100%"
        maxWidth={{ lg: '1400px' }}
        paddingY={{ xl: '16', md: '12', sm: '10', default: '10' }}
        paddingX={{ xl: '0', md: '8', default: '6' }}
      >
        <Typography color="orange_700" fontWeight="semibold" size="b_sm" textAlign={{ default: 'center', md: 'start' }}>
          {translate('referral_program_perseus.steps_to_reward.sub_title').toUpperCase()}
        </Typography>

        <Stack
          justifyContent="spaceBetween"
          alignItems="center"
          direction={{ default: 'column', md: 'row' }}
          marginTop="5"
          marginBottom="10"
          gap="6"
        >
          <h2>
            <I18n k="referral_program_perseus.steps_to_reward.title" />
          </h2>
          <Button onClick={onTermsClick} href={termsAndConditionsLink} target="_blank" intent="primary" variant="ghost">
            <I18n k="referral_program_perseus.steps_to_reward.terms" />
          </Button>
        </Stack>

        <Stack
          as="ul"
          gap={{ default: '10', md: '16' }}
          direction={{ default: 'column', md: 'row' }}
          justifyContent={{ md: 'spaceBetween' }}
        >
          {STEPS.map(({ id, title, text, icon }) => (
            <Stack key={id} as="li" direction="column" flex="1" alignItems={{ default: 'center', md: 'baseline' }}>
              <Image
                src={icon}
                alt={translate('referral_program_perseus.steps_to_reward.reward_icon')}
                width="80px"
                height="80px"
              />
              <Heading as="h5" marginBottom="2" marginTop="6">
                <I18n k={title} />
              </Heading>
              <Text size={{ default: 'b_sm', md: 'b_md' }} color="bodySecondary">
                <I18n k={text} />
              </Text>
            </Stack>
          ))}
        </Stack>
      </Container>
    </Container>
  );
};
